import { useLocation } from "react-router-dom";

export function useRouteMatch(paths: string[]): boolean {
  const { pathname } = useLocation();

  return paths.some((path) => {
    // For the base path "/", ensure it matches exactly and does not just start with "/"
    if (path === "/") {
      return pathname === "/";
    }
    // For other paths, ensure the path matches exactly or is a base for a deeper path
    const regex = new RegExp(`^${path}(/|$)`);
    return regex.test(pathname);
  });
}
